import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { PageHeaderTranslationFragment } from "@saleor/fragments/types/PageHeaderTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsPageHeaderPageProps
  extends TranslationsEntitiesPageProps {
  pageHeader: PageHeaderTranslationFragment;
}

export const fieldNames = {
  name: "name",
  pcContent: "pcContent",
  mobileContent: "mobileContent"
};

const TranslationsPageHeaderPage: React.FC<TranslationsPageHeaderPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  pageHeader,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage:
              'Translation Page Header "{pageHeaderName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            pageHeaderName: maybe(() => pageHeader.name, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Page Header Name"
            }),
            name: fieldNames.name,
            translation: maybe(() =>
              pageHeader.translation ? pageHeader.translation.name : null
            ),
            type: "short" as "short",
            value: maybe(() => pageHeader.name)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "PC Content",
              description: "pageHeader content"
            }),
            name: fieldNames.pcContent,
            translation: maybe(() =>
              pageHeader.translation ? pageHeader.translation.pcContent : null
            ),
            type: "long" as "long",
            value: maybe(() => pageHeader.pcContent)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "MB Content",
              description: "pageHeader content"
            }),
            name: fieldNames.mobileContent,
            translation: maybe(() =>
              pageHeader.translation
                ? pageHeader.translation.mobileContent
                : null
            ),
            type: "long" as "long",
            value: maybe(() => pageHeader.mobileContent)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
    </Container>
  );
};
TranslationsPageHeaderPage.displayName = "TranslationsPageHeaderPage";
export default TranslationsPageHeaderPage;
